var exports = {
  "kL": "WebhookListItem.module__container___YWRNR1",
  "aY": "WebhookListItem.module__headerButton___YWRNR1",
  "kb": "WebhookListItem.module__left___YWRNR1",
  "Jb": "WebhookListItem.module__avatarLarge___YWRNR1",
  "fI": "WebhookListItem.module__textBlock___YWRNR1",
  "$": "WebhookListItem.module__titleRow___YWRNR1",
  "UU": "WebhookListItem.module__name___YWRNR1",
  "ML": "WebhookListItem.module__channelTag___YWRNR1",
  "KW": "WebhookListItem.module__metaRow___YWRNR1",
  "K9": "WebhookListItem.module__channelTagMobile___YWRNR1",
  "ai": "WebhookListItem.module__chevron___YWRNR1",
  "hg": "WebhookListItem.module__chevronExpanded___YWRNR1",
  "zH": "WebhookListItem.module__details___YWRNR1",
  "J1": "WebhookListItem.module__detailsRow___YWRNR1",
  "Mc": "WebhookListItem.module__avatarColumn___YWRNR1",
  "Pf": "WebhookListItem.module__label___YWRNR1",
  "_Q": "WebhookListItem.module__avatarPreview___YWRNR1",
  "OA": "WebhookListItem.module__fields___YWRNR1",
  "EN": "WebhookListItem.module__fieldsRow___YWRNR1",
  "ch": "WebhookListItem.module__fieldGrow___YWRNR1",
  "o1": "WebhookListItem.module__actions___YWRNR1",
  "Dy": "WebhookListItem.module__avatarActions___YWRNR1",
  "B": "WebhookListItem.module__urlWrapper___YWRNR1",
  "UQ": "WebhookListItem.module__monoInput___YWRNR1",
  "Bx": "WebhookListItem.module__iconSmall___YWRNR1",
  "xv": "WebhookListItem.module__truncate___YWRNR1",
};

module.exports = exports;
